var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slick',{staticClass:"listing-slider mfp-gallery-container margin-bottom-0",attrs:{"options":_vm.slickOptions}},[_vm._l((_vm.data),function(gallery,index){return [_c('div',{key:index,staticClass:"box"},[_c('img',{staticClass:"image",attrs:{"src":gallery.route,"alt":"image"}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }